import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { PipeModule } from "../../../../../../pipes/pipes.module";
import { CustomerSelectorPopoverItemModule } from "../customer-selector-popover-item/customer-selector-popover-item.module";
import { CustomerSelectorPopoverComponent } from "./customer-selector-popover.component";

@NgModule({
	declarations: [CustomerSelectorPopoverComponent],
	imports: [CustomerSelectorPopoverItemModule, CommonModule, IonicModule, PipeModule],
	exports: [CustomerSelectorPopoverComponent]
})
export class CustomerSelectorPopoverModule {}
